<template>
    <div class="ku-shop-index">

        <div class="ku-span-title">
            <span><label>管理菜品类别</label><van-icon name="plus" @click="tab_show = true"/></span>
            <van-button class="copy" @click="copy_show = true">同步</van-button>
        </div>
        <van-grid class="grid" :column-num="tab_num">
            <van-grid-item v-for="(item, index) in tab_A" :key="index" @click="tab_edit(item)">
                <span>{{ item.name }}</span>
                <span>{{ item.en_name }}</span>
            </van-grid-item>
        </van-grid>
        <div class="ku-span-title">
            <span><label>菜品条件管理</label><van-icon name="plus" @click="tabC_show = true"/></span>
            <div class="copy copy-2" @click="tabB_show = true">加条件 <van-icon name="plus" /></div>
        </div>
        <van-grid class="grid-raise" direction="horizontal" :border="true" :column-num="3">
            <van-grid-item v-for="(item, index) in tab_C" :key="index" @click="set_tab_c(item)">
                <span :class="{action: tabCid === item.id}"><van-icon size="18" @click.stop="tabC_edit(item)" name="edit" /> <label>{{ item.name }}</label> </span>
            </van-grid-item>

<!--            <div class="icon" @click="tabB_show = true"><van-icon name="plus" /></div>-->
        </van-grid>

        <van-grid class="grid-raise" direction="horizontal" :border="true" :column-num="3">
            <van-grid-item v-for="(item, index) in tab_B" :key="index" @click="tabB_edit(item)">
                <span :class="{ 'raise-empty': !item.category_id, 'raise-off': item.show_status === 0 || item.show_status === '0' || item.status === 0 || item.on === 0 }">{{ item.name }} {{ item.price ? item.price : '' }}</span>
            </van-grid-item>
        </van-grid>
        <div class="ku-span-title time-row">
            <span><label>各项时间设置</label></span>
        </div>

        <div class="morning-mode-card">
            <div class="morning-mode-text">
                <div class="morning-mode-title">特惠早餐 / 早餐菜单</div>
                <div class="morning-mode-desc">控制顾客端「特惠早餐」入口；须同时开下方「早餐」餐段且在时段内</div>
            </div>
            <van-button
                class="button morning-btn"
                :class="{ text_kai: morning_switch === 1 }"
                @click="morningSwitch()"
            >早餐模式 {{ morning_str }}</van-button>
        </div>

        <WeekHours ref="weekHours" @pick-range="onWeekHoursPickRange" @pick-time="onWeekHoursPick" />

        <div class="ku-span">
            <div class="ku-span-title">
                <span><label>打包餐具价格</label></span>
            </div>

            <div class="ku-span-title">
                <span><label>外卖售后电话</label></span>
            </div>
        </div>


        <div class="ku-span">
            <div class="ku-tableware">
                <div class="s1">餐具</div>
                <div class="s1">1份</div>
                <van-field v-model="tableware" type="number" @blur="tableware_blur"/>
                <div class="s1">元</div>
            </div>

            <div class="span-1">
                <van-field v-model="wm_tel" @blur="wm_tel_blur"/>
            </div>
        </div>

        <div class="ku-span">
            <div class="ku-span-title">
                <span><label>起送金额</label></span>
            </div>

            <div class="ku-span-title">
                <span><label>外送费</label></span>
            </div>
        </div>

        <div class="ku-span">
            <div class="span-1">
                <van-field v-model="min_fee" type="number" @blur="setMinFee" placeholder="元"/>
            </div>

            <div class="span-1">
                <van-field v-model="delivery" type="number" @blur="setDelivery" placeholder="元"/>
            </div>
        </div>

        <div class="ku-span-title">
            <span><label>软件登录密码设置</label></span>
        </div>

        <div class="ku-span-password">
            <van-field v-model="password" placeholder="密码" type="password"/>
            <van-field v-model="re_password" placeholder="再次输入密码" type="password"/>
            <van-button type="primary" @click="setPassword">确定</van-button>
        </div>

        <div class="ku-span-title" v-if="shop_info.user_id === 24147">
            <span><label>支付切换</label></span>
        </div>

        <div class="pay_system" v-if="shop_info.user_id === 24147">
            <van-button plain type="primary" v-if="shop_info.pay_system === 2" @click="onPaySystem(1)">官方支付开
            </van-button>
            <van-button plain type="default" v-if="shop_info.pay_system === 1" @click="onPaySystem(2)">官方支付关
            </van-button>
        </div>

        <div class="ku-shop-qrcode">

            <van-image :src="image"/>

            <div class="s2">
                <van-image fit="contain" @click="jt2" :src="require('../../assets/jt.png')"/>
                <van-field
                    readonly
                    clickable
                    :value="value"
                    @click="showPicker = true"
                />
                <van-image fit="contain" @click="jt1" :src="require('../../assets/jt1.png')"/>
                <div>
                    <van-button @click="downLoad" class="nowBtn">下载</van-button>
                </div>
            </div>

            <van-popup v-model="showPicker" round position="bottom">
                <van-picker
                    show-toolbar
                    title="选择桌码"
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                />
            </van-popup>

            <div class="s1" style="display: none">
                左边为桌码，点餐及上传卓码二合一<br>右边为公众号，可远程点餐，两者都可以堂吃点餐<br>小技巧：一个大长桌可以一个号，多打印几份
            </div>

        </div>

        <div class="ku-shop-qrcode">

            <van-image :src="image2"/>

        </div>

        <!--设置-->
        <div class="ku-span-title">
            <span><label>店铺、广告图设置</label></span>
        </div>
        <div class="ku-span-upload" style="display: flex; justify-content: center">
            <div class="ku-upload" span="12">
                <van-uploader :after-read="image1_afterRead" v-model="img1" :max-width="200" upload-text="店铺图" :max-count="1" :max-size="2 * 1024 * 1024"/>
            </div>

            <div class="ku-upload" span="12">
                <van-uploader :after-read="image2_afterRead" v-model="img2" upload-text="广告图" :max-count="1" :max-size="2 * 1024 * 1024"/>
            </div>
        </div>

        <div class="ku-span-title">
            <span><label>首页广告图设置</label></span>
        </div>
        <div class="ku-span-upload ku-span-upload-1" style="display: flex; flex-direction: column; justify-content: center">
            <div class="ku-upload">
                <van-uploader :after-read="image_index_afterRead" :before-delete="image_index_delete" v-model="img_index" :max-width="600" upload-text="店铺图" :max-count="1" :max-size="2 * 1024 * 1024"/>
            </div>

            <div class="Switch">
                <div>只显示一次：</div>
                <van-switch v-model="index_switch" @change="onChangeSwitch" active-color="#E68925" size="24px" />
            </div>
        </div>

        <div class="ku-shop-qrcode">

            <van-image :src="image_mini"/>

            <div class="s2">
                <van-image fit="contain" @click="tj2" :src="require('../../assets/jt.png')"/>
                <van-field
                    readonly
                    clickable
                    :value="value"
                    @click="showPicker = true"
                />
                <van-image fit="contain" @click="tj1" :src="require('../../assets/jt1.png')"/>
                <div>
                    <van-button @click="downLoad_mini" class="nowBtn">下载</van-button>
                </div>
            </div>

            <van-popup v-model="showPicker" round position="bottom">
                <van-picker
                    show-toolbar
                    title="选择桌码"
                    :columns="columns"
                    @confirm="onConfirmini"
                    @cancel="showPicker = false"
                />
            </van-popup>

        </div>
        <div class="ku-span-title">
            <span><label>折扣配置</label><van-icon name="plus" @click="tabZ_show = true"/></span>
        </div>
        <van-grid class="grid-raise" direction="horizontal" :border="true" :column-num="2">
            <van-grid-item v-for="(item, index) in tab_Z" :key="index">
                <span>人数：{{ item.numbers }} 折扣：{{ item.rate ? item.rate * 100 + "折" : '' }}</span>
            </van-grid-item>
        </van-grid>

        <div class="ku-span-title">
            <span><label>运费配置</label><van-icon name="plus" @click="onDistance([], 'add')"/></span>
        </div>
        <div class="Switch">
            <div>启用自定义：</div>
            <van-switch v-model="carriage_status" @change="onChangeCarriage" active-color="#E68925" size="24px" />
        </div>
        <van-grid class="grid-raise" direction="horizontal" :border="true" :column-num="2">
            <van-grid-item v-for="(item, index) in distance" :key="index">
                <span @click="onDistance(item, 'edit')">{{ item.carriage_text }}</span>
            </van-grid-item>
        </van-grid>

        <van-popup round closeable close-icon="close" v-model="tab_show" @closed="tab_close" class="tab_show">
            <div class="title">类别</div>
            <van-field v-model="tab_name" label="类别名" placeholder="类别名"/>
            <van-field v-model="tab_en_name" label="英文" placeholder="英文"/>
            <van-field v-model="tab_sort" type="number" label="排序" placeholder="排序"/>
            <div class="foot">
                <van-button type="default" @click="tab_del">删除</van-button>
                <van-button type="default" @click="tab_confirm">确认</van-button>
            </div>
        </van-popup>

        <van-popup round closeable close-icon="close" v-model="tabB_show" @closed="tabB_close" class="tab_show">
            <div class="title">附加条件</div>
            <van-field v-model="tabB_name" label="附加条件" placeholder="附加条件"/>
            <van-field v-model="tabB_category_name" label="类别" placeholder="类别" readonly @click="tabBC_show = true" />
            <van-field v-model="tabB_price" type="number" label="价格" placeholder="价格"/>
            <van-field v-model="tabB_sort" type="number" label="排序" placeholder="排序"/>
            <div class="wh-pop-shelf">
                <div class="wh-pop-shelf-label">售卖状态</div>
                <div class="wh-pop-shelf-btns">
                    <van-button size="small" :class="{active: tabB_status !== 0}" type="primary" @click="tabB_status = 1">上架</van-button>
                    <van-button size="small" :class="{active: tabB_status === 0}" @click="tabB_status = 0">下架</van-button>
                </div>
            </div>
            <div class="foot">
                <van-button type="default" @click="tabB_del">删除</van-button>
                <van-button type="default" @click="tabB_confirm">确认</van-button>
            </div>
        </van-popup>

        <van-popup round closeable close-icon="close" v-model="tabC_show" @closed="tabC_close" class="tab_show">
            <div class="title">条件分类</div>
            <van-field v-model="tabC_name" label="分类名称" placeholder="分类名称" />
            <van-field v-model="tabC_sort" type="number" label="排序" placeholder="排序"/>
            <div class="foot">
                <van-button type="default" @click="tabC_del">删除</van-button>
                <van-button type="default" @click="tabC_confirm">确认</van-button>
            </div>
        </van-popup>

        <van-popup round closeable close-icon="close" v-model="distance_show" class="tab_show">
            <div class="title">运费规则</div>
            <van-field v-model="distance_data.start_distance" label="开始距离" placeholder="开始距离" />
            <van-field v-model="distance_data.end_distance" type="number" label="结束距离" placeholder="结束距离"/>
            <van-field v-model="distance_data.price" type="number" label="运费价格" placeholder="运费价格"/>
            <div class="foot">
                <van-button type="default" v-if="distance_data.id > 0" @click="distance_del">删除</van-button>
                <van-button type="default" @click="distance_confirm">确认</van-button>
            </div>
        </van-popup>

        <van-popup round closeable close-icon="close" v-model="tabZ_show" class="tabz_show">
<!--            <el-form-item v-for="(item,index) in map" :key="item[0]" :label="item[0]">-->
<!--                <div class="tabz_discount">-->
<!--                    <van-field v-model="discount[index]" type="number" label="人数" placeholder="人数"/>-->
<!--                    <van-field v-model="discount[rate]" type="number" label="折扣率" placeholder="折扣率"/>-->
<!--                </div>-->
<!--            </el-form-item>-->
            <van-field v-model="tabZ_numbers" type="number" label="人数" placeholder="人数"/>
            <van-field v-model="tabZ_rate" type="number" label="折扣率" placeholder="折扣率"/>
            <!-- <div class="foot">
                <van-button type="default" @click="tabZ_del">删除</van-button>
                <van-button type="default" @click="tabZ_confirm">确认</van-button>
            </div>-->
        </van-popup>

        <van-popup round closeable close-icon="close" v-model="copy_show" @closed="copy_close" class="tab_show popup-copy">
            <div class="title">是否同步</div>
            <van-radio-group v-model="copy_id">
                <van-radio
                    :name="item.id"
                    :class="{'radio-active': copy_id === item.id}"
                    v-show="item.id !== shop_id"
                    v-for="(item, index) in shopInfo"
                    :key="index">{{ item.shop_name }}
                </van-radio>
            </van-radio-group>
            <div class="foot">
                <van-button type="default" @click="copy_confirm">确认</van-button>
            </div>
        </van-popup>

        <van-popup round close-icon="close" v-model="tabBC_show" position="bottom">
            <van-picker
                title="选择分类"
                show-toolbar
                :columns="tab_CC"
                @confirm="onCConfirm"
                @cancel="onCCancel"
            />
        </van-popup>

        <!-- dual start/end time range popup -->
        <van-popup v-model="range_show" position="bottom" round :style="{ height: 'auto' }" class="time-range-popup">
            <div class="time-range-toolbar">
                <button type="button" class="tr-btn tr-cancel" @click="closeRangePicker">取消</button>
                <div class="tr-title">选择时段</div>
                <button type="button" class="tr-btn tr-ok" @click="stRangeTime">确认</button>
            </div>
            <div class="time-range-cols">
                <div class="time-range-col">
                    <div class="time-range-label">开</div>
                    <van-datetime-picker
                        v-model="rangeStart"
                        type="time"
                        :show-toolbar="false"
                        :visible-item-count="5"
                        :item-height="36"
                    />
                </div>
                <div class="time-range-col">
                    <div class="time-range-label">关</div>
                    <van-datetime-picker
                        v-model="rangeEnd"
                        type="time"
                        :show-toolbar="false"
                        :visible-item-count="5"
                        :item-height="36"
                    />
                </div>
            </div>
        </van-popup>

        <!-- legacy single picker kept only if something still emits pick-time without pair -->
        <van-overlay :show="time_show" @click="time_show = false"/>
        <van-datetime-picker v-show="time_show" v-model="currentTime" @cancel="time_show = false" @confirm="stTime" type="time" title="选择时间"/>

        <FootTab :tab-key="tabKey" :head-key="headKey"></FootTab>
    </div>
</template>

<script>

import Vue from 'vue';
import {
    Button,
    Field,
    Grid,
    GridItem,
    Uploader,
    Notify,
    Popup,
    Icon,
    Dialog,
    DatetimePicker,
    Overlay,
    Image as VanImage,
    RadioGroup,
    Radio,
    Picker, Switch
} from 'vant';
import FootTab from '@/components/foot'
import WeekHours from '@/components/WeekHours'
import {getCookie, setShop} from "@/utils/auth";
import QRCode from "qrcodejs2";

Vue.use(Field).use(Button).use(Notify).use(Icon).use(DatetimePicker)
    .use(Popup).use(Grid).use(GridItem).use(Uploader).use(Dialog).use(Overlay).use(VanImage)
    .use(RadioGroup).use(Radio).use(Picker).use(Switch);

export default {
    name: "shop_index",
    components: {
        FootTab,
        WeekHours,
    },
    data() {
        return {
            shop_id: 0,
            shop_info: [],
            shopInfo: [],
            headKey: 'index',
            headTop: false,
            tabKey: 'index',
            tab_num: 6,
            tab_c_id: 0,
            tab_A: [],
            tab_B: [],
            tab_C: [],
            tab_CC: [],
            tab_Z: [],
            item_image: {
                image1: '',
                image2: '',
            },
            tabZ_numbers: "",
            tabZ_rate: "",
            // 同步
            copy_show: false,
            copy_id: 0,

            tab_id: '',
            tab_name: '',
            tab_en_name: '',
            tab_sort: '',
            tab_show: false,

            tabB_id: '',
            tabB_name: '',
            tabB_category: 0,
            tabB_category_name: '',
            tabB_price: '',
            tabB_sort: '',
            tabB_show: false,
            tabB_status: 1,
            tabBC_show: false,

            tabCid: 0,
            tabC_show: false,
            tabC_id: '',
            tabC_name: '',
            tabC_sort: '',

            tabZ_show: false,
            img1: [],
            img2: [],
            img_index: [],

            time_show: false,
            time_string: '',
            currentTime: '07:00',

            range_show: false,
            rangeStart: '07:00',
            rangeEnd: '22:00',
            rangeMeta: null,

            ts_switch: '开',
            ts_start_time: '07:00',
            ts_end_time: '10:00',
            ts_start_we: '07:00',
            ts_end_we: '10:00',

            wm_switch: '开',
            wm_start_time: '07:00',
            wm_end_time: '10:00',
            wm_start_we: '07:00',
            wm_end_we: '10:00',

            afternoon_start_time: '',
            afternoon_end_time: '',

            morning_str: '关',
            morning_switch: 0,
            morning_start_time: '07:00',
            morning_end_time: '10:00',
            in_start_time: '10:00',
            in_end_time: '18:00',
            night_start_time: '17:00',
            night_end_time: '21:00',

            tableware: 0,
            wm_tel: '', // 外卖配送电话
            min_fee: '',
            delivery: '',
            password: '',
            re_password: '',

            qrCode: '',
            value: '1 号桌码',
            showPicker: false,
            image: '',
            image2: '',
            image_index: '',
            image_mini: '',
            keyId: 1,
            map: [1,2],
            discount: [],
            columns: [
                {"keyId": 1, "text": "1 号桌码"},
                {"keyId": 2, "text": "2 号桌码"},
                {"keyId": 3, "text": "3 号桌码"},
                {"keyId": 4, "text": "4 号桌码"},
                {"keyId": 5, "text": "5 号桌码"},
                {"keyId": 6, "text": "6 号桌码"},
                {"keyId": 7, "text": "7 号桌码"},
                {"keyId": 8, "text": "8 号桌码"},
                {"keyId": 9, "text": "9 号桌码"},
                {"keyId": 10, "text": "10 号桌码"},
                {"keyId": 11, "text": "11 号桌码"},
                {"keyId": 12, "text": "12 号桌码"},
                {"keyId": 13, "text": "13 号桌码"},
                {"keyId": 14, "text": "14 号桌码"},
                {"keyId": 15, "text": "15 号桌码"},
                {"keyId": 16, "text": "16 号桌码"},
                {"keyId": 17, "text": "17 号桌码"},
                {"keyId": 18, "text": "18 号桌码"},
                {"keyId": 19, "text": "19 号桌码"},
                {"keyId": 20, "text": "20 号桌码"},
            ],

            index_switch: false,
            distance: [],
            carriage_status: false,
            distance_show: false,
            distance_data: {},
        }
    },
    mounted() {
        let that = this
        let shop = JSON.parse(getCookie('shop'))
        that.shopInfo = JSON.parse(getCookie('shopInfo'))
        that.shop_id = shop.id
        that.$API.applyInfo({id: that.shop_id}).then(res => {
            let data = res.data
            that.min_fee = data.min_fee
            that.delivery = data.delivery
            that.wm_tel = data.wm_tel
            that.tableware = data.tableware
            that.ts_switch = data.ts_switch ? '开' : '关'
            that.wm_switch = data.wm_switch ? '开' : '关'
            that.setMorningSwitch(data.morning_switch)
            that.img1.push({url: data.image})
            that.img2.push({url: data.ad_image})
            if (data.index_image) {
                that.img_index.push({url: data.index_image})
            }
            that.index_switch = data.index_switch === 1
        })
        this.tab_foodCategory()
        that.onConfirm({"keyId": 1, "text": "1 号桌码"});
        that.onConfirmini({"keyId": 1, "text": "1 号桌码"});
    },
    methods: {
        // 获取分类
        tab_foodCategory() {
            let _this = this
            _this.tab_A = []
            _this.tab_B = []
            _this.tab_C = []
            _this.tab_CC = []
            _this.tab_Z = []
            // 获取全部类别
            _this.$API.foodCategory().then(res => {
                res.data.list.forEach(function (item) {
                    _this.tab_A.push(item)
                });
                _this.tab_num = res.data.total
            })
            // 附加条件分类
            _this.$API.foodRaiseCategory().then(res => {
                res.data.list.forEach(function (item) {
                    _this.tab_C.push(item)
                    _this.tab_CC.push(item.name || '')
                });
            })
            // 获取全部附加条件
            this.getTabB()
            _this.$API.applyInfo({id: _this.shop_id}).then(res => {
                let data = res.data
                _this.shop_info = res.data
                _this.ts_start_time = data.ts_start
                _this.ts_start_we = data.ts_start_we || data.ts_start
                _this.ts_end_we = data.ts_end_we || data.ts_end
                _this.wm_start_we = data.wm_start_we || data.wm_start
                _this.wm_end_we = data.wm_end_we || data.wm_end
                _this.ts_end_time = data.ts_end
                _this.wm_start_time = data.wm_start
                _this.wm_end_time = data.wm_end
                _this.image2 = data.qrcode
                _this.setMorningSwitch(data.morning_switch)
            })
            _this.$API.shopDiscount().then(res => {
                res.data.forEach(function (item) {
                    _this.tab_Z.push(item)
                });
            })
            _this.getDistance();
            // 获取营业时间
            _this.$API.shopHours().then(res => {
                let data = res.data
                _this.morning_start_time = data.morning_start_time
                _this.morning_end_time = data.morning_end_time
                _this.in_start_time = data.in_start_time
                _this.in_end_time = data.in_end_time
                _this.afternoon_start_time = data.afternoon_start_time
                _this.afternoon_end_time = data.afternoon_end_time
                _this.night_start_time = data.night_start_time
                _this.night_end_time = data.night_end_time
                if (data.morning_switch !== undefined && data.morning_switch !== null) {
                    _this.setMorningSwitch(data.morning_switch)
                }
            })
        },
        getTabB() {
            let _this = this
            _this.tab_B = []
            _this.$API.foodRaise({type: _this.tabCid}).then(res => {
                res.data.list.forEach(function (item) {
                    _this.tab_B.push(item)
                });
            })
        },
        tab_edit(item) {
            this.tab_id = item.id
            this.tab_name = item.name
            this.tab_en_name = item.en_name
            this.tab_sort = item.sort
            this.tab_show = true
        },
        // 新增类别
        tab_confirm() {
            let _this = this
            if (!this.tab_name.length) {
                Notify('请输入类别名');
                return false;
            }

            let params = {
                id: _this.tab_id,
                name: _this.tab_name,
                en_name: _this.tab_en_name,
                sort: _this.tab_sort
            }
            // 保存到数据库
            _this.$API.foodCategorySave(params).then(res => {
                _this.tab_confirm_null(res.data)
                _this.tab_show = false
            })
        },
        set_tab_c(item) {
            this.tabCid = item.id === this.tabCid ? 0 : item.id
            this.getTabB()
        },
        tabC_edit(item) {
            this.tabC_id = item.id
            this.tabC_name = item.name
            this.tabC_sort = item.sort
            this.tabC_show = true
        },
        tab_del() {
            let _this = this
            Dialog.confirm({
                title: '删除类别',
                message: '确认要删除类别(' + _this.tab_name + ')吗？',
            }).then(() => {
                _this.$API.foodCategoryDel({id: _this.tab_id}).then(res => {
                    _this.tab_confirm_null(res.data)
                    _this.tab_show = false
                    Notify({type: 'success', message: '删除成功'});
                })
            }).catch(() => {
            });
        },
        tab_close() {
            this.tab_id = ''
            this.tab_name = ''
            this.tab_en_name = ''
            this.tab_sort = ''
        },
        tab_confirm_null(data) {
            let _this = this
            this.tab_close()
            if (data) {
                // 重排序
                _this.tab_A = []
                data.list.forEach(function (item) {
                    _this.tab_A.push(item)
                });
                _this.tab_num = data.total
            }
        },

        tabB_edit(item) {
            this.tabB_id = item.id
            this.tabB_name = item.name
            this.tabB_category = item.category_id
            this.tabB_category_name = item.category_name
            if (!this.tabB_category_name && this.tabB_category && this.tab_C) {
                const hit = this.tab_C.find(c => String(c.id) === String(this.tabB_category))
                if (hit) this.tabB_category_name = hit.name
            }
            this.tabB_price = item.price
            this.tabB_sort = item.sort
            this.tabB_status = (item.show_status === 0 || item.show_status === "0" || item.status === 0 || item.on === 0) ? 0 : 1
            this.tabB_show = true
        },
        // 新增条件
        tabB_confirm() {
            let _this = this
            if (!this.tabB_name.length) {
                Notify('请输入条件名');
                return false;
            }

            let params = {
                id: _this.tabB_id,
                name: _this.tabB_name,
                category: _this.tabB_category,
                price: _this.tabB_price,
                sort: _this.tabB_sort,
                status: _this.tabB_status
            }
            // 保存到数据库
            _this.$API.foodRaiseSave(params).then(res => {
                if (_this.tabB_id && _this.$API.foodRaiseStatus) {
                    _this.$API.foodRaiseStatus({ id: _this.tabB_id, status: _this.tabB_status, show_status: _this.tabB_status })
                }
                _this.tabB_confirm_null(res.data)
                _this.tabB_show = false
            })
        },
        copy_confirm() {
            let that = this;
            if (!that.copy_id) {
                Notify('强选择要同步的店铺');
                return false;
            }

            Dialog.confirm({
                title: '警告',
                message: '确认同步菜品及分类到本店吗？已添加菜品及分类将全部删除',
            }).then(() => {
                that.$API.shopCopy({id: that.shop_id, copy_id: that.copy_id}).then(() => {
                    that.tab_foodCategory()
                    that.copy_show = false
                })
            }).catch(() => {
                // on cancel
            });
        },
        tabB_del() {
            let _this = this
            Dialog.confirm({
                title: '删除类别',
                message: '确认要删除条件(' + _this.tabB_name + ')吗？',
            }).then(() => {
                _this.$API.foodRaiseDel({id: _this.tabB_id}).then(res => {
                    _this.tabB_confirm_null(res.data)
                    _this.tabB_show = false
                    Notify({type: 'success', message: '删除成功'});
                })
            }).catch(() => {
            });
        },
        tabB_close() {
            this.tabB_id = ''
            this.tabB_name = ''
            this.tabB_price = ''
            this.tabB_sort = ''
        },
        tabC_close() {
            this.tabC_id = ''
            this.tabC_name = ''
            this.tabC_sort = ''
        },
        tabC_del() {
            let _this = this
            Dialog.confirm({
                title: '删除类别',
                message: '确认要删除条件分类(' + _this.tabC_name + ')吗？',
            }).then(() => {
                _this.$API.foodRaiseCategoryDel({id: _this.tabC_id}).then(res => {
                    _this.tabC_confirm_null(res.data)
                    _this.tabC_show = false
                    Notify({type: 'success', message: '删除成功'});
                })
            }).catch(() => {
            });
        },
        tabC_confirm() {
            let _this = this
            if (!this.tabC_name.length) {
                Notify('请输入名称');
                return false;
            }

            let params = {
                id: _this.tabC_id,
                name: _this.tabC_name,
                sort: _this.tabC_sort
            }
            // 保存到数据库
            _this.$API.foodRaiseCategorySave(params).then(res => {
                _this.tabC_confirm_null(res.data)
                _this.tabC_show = false
            })
        },
        tabC_confirm_null(data) {
            let _this = this
            this.tabC_close()
            if (data) {
                // 重排序
                _this.tab_C = []
                _this.tab_CC = []
                data.list.forEach(function (item) {
                    _this.tab_C.push(item)
                    _this.tab_CC.push(item.name || '')
                });
            }
        },
        copy_close() {
            this.copy_id = 0
        },
        tabB_confirm_null(data) {
            let _this = this
            this.tabB_close()
            if (data) {
                // 重排序
                _this.tab_B = []
                data.list.forEach(function (item) {
                    _this.tab_B.push(item)
                });
            }
        },
        onWeekHoursPickRange(payload) {
            if (!payload) return
            this.rangeMeta = {
                kind: payload.kind,
                startType: payload.startType,
                endType: payload.endType
            }
            this.rangeStart = payload.start || '07:00'
            this.rangeEnd = payload.end || '22:00'
            this.range_show = true
        },
        closeRangePicker() {
            this.range_show = false
            this.rangeMeta = null
        },
        applyLocalTimeField(type, value) {
            switch (type) {
                case 'ts_start':
                    this.ts_start_time = value
                    break
                case 'ts_end':
                    this.ts_end_time = value
                    break
                case 'ts_start_we':
                    this.ts_start_we = value
                    break
                case 'ts_end_we':
                    this.ts_end_we = value
                    break
                case 'wm_start':
                    this.wm_start_time = value
                    break
                case 'wm_end':
                    this.wm_end_time = value
                    break
                case 'wm_start_we':
                    this.wm_start_we = value
                    break
                case 'wm_end_we':
                    this.wm_end_we = value
                    break
                case 'morning_start':
                    this.morning_start_time = value
                    break
                case 'morning_end':
                    this.morning_end_time = value
                    break
                case 'in_start':
                    this.in_start_time = value
                    break
                case 'in_end':
                    this.in_end_time = value
                    break
                case 'afternoon_start':
                    this.afternoon_start_time = value
                    break
                case 'afternoon_end':
                    this.afternoon_end_time = value
                    break
                case 'night_start':
                    this.night_start_time = value
                    break
                case 'night_end':
                    this.night_end_time = value
                    break
            }
        },
        stRangeTime() {
            const meta = this.rangeMeta
            if (!meta) {
                this.closeRangePicker()
                return
            }
            const startVal = this.rangeStart
            const endVal = this.rangeEnd
            const startType = meta.startType
            const endType = meta.endType
            const wh = this.$refs.weekHours

            // channel: 堂食/外卖 工作日 or 周末 — one ts_week/wm_week JSON save
            if (meta.kind === 'channel'
                || /^(ts|wm)_(start|end)(_we)?$/.test(startType)) {
                let payload = { type: startType, value: startVal }
                if (wh && wh.buildChannelWeekRangeSave) {
                    const built = wh.buildChannelWeekRangeSave(startType, endType, startVal, endVal)
                    if (built) payload = built
                } else if (wh && wh.buildChannelWeekSave) {
                    wh.buildChannelWeekSave(startType, startVal)
                    const built = wh.buildChannelWeekSave(endType, endVal)
                    if (built) payload = built
                }
                this.$API.shopEditHours(payload).then(() => {
                    Notify({ type: 'success', message: '修改成功' })
                    this.applyLocalTimeField(startType, startVal)
                    this.applyLocalTimeField(endType, endVal)
                    if (wh) {
                        if (payload.type === 'ts_week' || payload.type === 'wm_week') {
                            const ch = payload.type === 'ts_week' ? 'ts' : 'wm'
                            if (wh.applyWeekSaved) wh.applyWeekSaved(ch, payload.value)
                        } else if (wh.applySaved) {
                            wh.applySaved(startType, startVal)
                            wh.applySaved(endType, endVal)
                        }
                    }
                    this.closeRangePicker()
                }).catch(() => {
                    Notify({ type: 'danger', message: '修改失败' })
                })
                return
            }

            // meal: two shopHoursEdit calls then refresh WeekHours
            Promise.all([
                this.$API.shopHoursEdit({ type: startType, value: startVal }),
                this.$API.shopHoursEdit({ type: endType, value: endVal })
            ]).then(() => {
                Notify({ type: 'success', message: '修改成功' })
                this.applyLocalTimeField(startType, startVal)
                this.applyLocalTimeField(endType, endVal)
                if (wh && wh.applySaved) {
                    wh.applySaved(startType, startVal)
                    wh.applySaved(endType, endVal)
                }
                this.closeRangePicker()
            }).catch(() => {
                Notify({ type: 'danger', message: '修改失败' })
            })
        },
        onWeekHoursPick(type, value) {
            // Prefer dual range if WeekHours can resolve a pair
            if (this.$refs.weekHours && this.$refs.weekHours.resolvePair) {
                const pair = this.$refs.weekHours.resolvePair(type)
                if (pair) {
                    this.onWeekHoursPickRange(pair)
                    return
                }
            }
            if (value) {
                this.currentTime = value
                this.time_string = type
                this.time_show = true
                return
            }
            this.cu_time(type)
        },
        cu_time(type) {
            let _this = this
            switch (type) {
                case 'ts_start':
                    _this.currentTime = _this.ts_start_time
                    break;
                case 'ts_end':
                    _this.currentTime = _this.ts_end_time
                    break;
                case 'ts_start_we':
                    _this.currentTime = _this.ts_start_we
                    break;
                case 'ts_end_we':
                    _this.currentTime = _this.ts_end_we
                    break;
                case 'wm_start':
                    _this.currentTime = _this.wm_start_time
                    break;
                case 'wm_end':
                    _this.currentTime = _this.wm_end_time
                    break;
                case 'wm_start_we':
                    _this.currentTime = _this.wm_start_we
                    break;
                case 'wm_end_we':
                    _this.currentTime = _this.wm_end_we
                    break;
                case 'morning_start':
                    _this.currentTime = _this.morning_start_time
                    break;
                case 'morning_end':
                    _this.currentTime = _this.morning_end_time
                    break;
                case 'in_start':
                    _this.currentTime = _this.in_start_time
                    break;
                case 'in_end':
                    _this.currentTime = _this.in_end_time
                    break;
                case 'afternoon_start':
                    _this.currentTime = _this.afternoon_start_time
                    break;
                case 'afternoon_end':
                    _this.currentTime = _this.afternoon_end_time
                    break;
                case 'night_start':
                    _this.currentTime = _this.night_start_time
                    break;
                case 'night_end':
                    _this.currentTime = _this.night_end_time
                    break;
            }
            _this.time_show = true
            _this.time_string = type
        },
        stTime(value) {
            console.log(value)
            let _this = this
            // 堂食/外卖：工作日与周末分开写进 week JSON（不互相覆盖）
            if (_this.time_string === 'ts_start' || _this.time_string === 'ts_end'
                || _this.time_string === 'ts_start_we' || _this.time_string === 'ts_end_we'
                || _this.time_string === 'wm_start' || _this.time_string === 'wm_end'
                || _this.time_string === 'wm_start_we' || _this.time_string === 'wm_end_we') {
                let payload = { type: _this.time_string, value: value }
                if (_this.$refs.weekHours && _this.$refs.weekHours.buildChannelWeekSave) {
                    const built = _this.$refs.weekHours.buildChannelWeekSave(_this.time_string, value)
                    if (built) payload = built
                }
                _this.$API.shopEditHours(payload).then(() => {
                    Notify({type: 'success', message: '修改成功'});
                    switch (_this.time_string) {
                        case 'ts_start':
                            _this.ts_start_time = value
                            break;
                        case 'ts_end':
                            _this.ts_end_time = value
                            break;
                        case 'ts_start_we':
                            _this.ts_start_we = value
                            break;
                        case 'ts_end_we':
                            _this.ts_end_we = value
                            break;
                        case 'wm_start':
                            _this.wm_start_time = value
                            break;
                        case 'wm_end':
                            _this.wm_end_time = value
                            break;
                        case 'wm_start_we':
                            _this.wm_start_we = value
                            break;
                        case 'wm_end_we':
                            _this.wm_end_we = value
                            break;
                    }
                    if (_this.$refs.weekHours) {
                        if (payload.type === 'ts_week' || payload.type === 'wm_week') {
                            const ch = payload.type === 'ts_week' ? 'ts' : 'wm'
                            if (_this.$refs.weekHours.applyWeekSaved) {
                                _this.$refs.weekHours.applyWeekSaved(ch, payload.value)
                            }
                        } else if (_this.$refs.weekHours.applySaved) {
                            _this.$refs.weekHours.applySaved(_this.time_string, value)
                        }
                    }
                    this.time_show = false
                });
            } else {
                _this.$API.shopHoursEdit({
                    'type': _this.time_string,
                    'value': value
                }).then(() => {
                    Notify({type: 'success', message: '修改成功'});
                    switch (_this.time_string) {
                        case 'morning_start':
                            _this.morning_start_time = value
                            break;
                        case 'morning_end':
                            _this.morning_end_time = value
                            break;
                        case 'in_start':
                            _this.in_start_time = value
                            break;
                        case 'in_end':
                            _this.in_end_time = value
                            break;
                        case 'afternoon_start':
                            _this.afternoon_start_time = value
                            break;
                        case 'afternoon_end':
                            _this.afternoon_end_time = value
                            break;
                        case 'night_start':
                            _this.night_start_time = value
                            break;
                        case 'night_end':
                            _this.night_end_time = value
                            break;
                    }
                    if (_this.$refs.weekHours && _this.$refs.weekHours.applySaved) {
                        _this.$refs.weekHours.applySaved(_this.time_string, value)
                    }
                    this.time_show = false
                })
            }
        },
        tableware_blur() {
            this.$API.shopEdit({tableware: this.tableware}).then(res => {
                setShop(res.data)
                Notify({type: 'success', message: '设置成功'});
            })
        },
        tsSwitch() {
            this.$API.shopEdit({ts_switch: this.ts_switch === '开' ? 0 : 1}).then(res => {
                setShop(res.data)
                this.ts_switch = this.ts_switch === '开' ? '关' : '开'
                Notify({type: 'success', message: '设置成功'});
            })
        },
        wmSwitch() {
            this.$API.shopEdit({wm_switch: this.wm_switch === '开' ? 0 : 1}).then(res => {
                setShop(res.data)
                this.wm_switch = this.wm_switch === '开' ? '关' : '开'
                Notify({type: 'success', message: '设置成功'});
            })
        },
        setMorningSwitch(value) {
            const on = value === 1 || value === '1' || value === true || value === '开'
            this.morning_switch = on ? 1 : 0
            this.morning_str = on ? '开' : '关'
        },
        morningSwitch() {
            const next = this.morning_switch === 1 ? 0 : 1
            this.$API.shopEdit({morning_switch: next}).then(res => {
                if (res && res.data) {
                    setShop(res.data)
                    if (res.data.morning_switch !== undefined && res.data.morning_switch !== null) {
                        this.setMorningSwitch(res.data.morning_switch)
                    } else {
                        this.setMorningSwitch(next)
                    }
                } else {
                    this.setMorningSwitch(next)
                }
                Notify({type: 'success', message: '设置成功'});
            }).catch(() => {
                Notify({type: 'danger', message: '早餐模式设置失败'});
            })
        },
        wm_tel_blur() {
            this.$API.shopEdit({wm_tel: this.wm_tel}).then(res => {
                setShop(res.data)
                Notify({type: 'success', message: '设置成功'});
            })
        },
        setMinFee() {
            this.$API.shopEdit({min_fee: this.min_fee}).then(res => {
                setShop(res.data)
                Notify({type: 'success', message: '设置成功'});
            })
        },
        setDelivery() {
            this.$API.shopEdit({delivery: this.delivery}).then(res => {
                setShop(res.data)
                Notify({type: 'success', message: '设置成功'});
            })
        },
        onPaySystem(type) {
            let that = this
            this.$API.shopEdit({pay_system: type}).then(res => {
                that.shop_info = res.data
                Notify({type: 'success', message: '设置成功'});
            })
        },
        setPassword() {
            let _this = this
            if (_this.password === '') {
                Notify({type: 'danger', message: '请输入密码'});
                return false;
            }

            if (_this.re_password === '') {
                Notify({type: 'danger', message: '请输入确认密码'});
                return false;
            }

            if (_this.re_password !== _this.password) {
                Notify({type: 'danger', message: '两次密码不一致'});
                return false;
            }

            this.$API.shopEdit({password: _this.password}).then(() => {
                Notify({type: 'success', message: '密码设置成功'});
            })
        },
        downLoad() {
            window.open(this.image)
        },
        downLoad_mini(){
             window.open(this.image_mini)
        },
        qrcodeUrl(number) {
            this.qrCode = process.env.VUE_APP_USER_URL + '/place_order?coType=3&shopId=' + this.shop_id + (number > 0 ? '&number=' + number : '')
            console.log(this.qrCode)
            this.qrcode()
        },
        qrcode() {
            let qr = document.getElementById("qrcode");
            qr.innerHTML = "";
            new QRCode('qrcode', {
                width: 320,
                height: 320,
                text: this.qrCode, // 二维码地址
                colorDark: "#000",
                colorLight: "#fff",
            })
        },
        jt1() {
            if (this.keyId < 20) {
                this.keyId += 1;
                this.onConfirm({"keyId": this.keyId, "text": this.keyId + " 号桌码"})
            }
        },
        jt2() {
            if (this.keyId > 1) {
                this.keyId -= 1;
                this.onConfirm({"keyId": this.keyId, "text": this.keyId + " 号桌码"})
            }
        },
        tj1() {
            if (this.keyId < 20) {
                this.keyId += 1;
                this.onConfirmini({"keyId": this.keyId, "text": this.keyId + " 号桌码"})
            }
        },
        tj2() {
            if (this.keyId > 1) {
                this.keyId -= 1;
                this.onConfirmini({"keyId": this.keyId, "text": this.keyId + " 号桌码"})
            }
        },
        image1_afterRead(file, detail) {
            this.afterRead(file, detail, 'image')
        },
        image2_afterRead(file, detail) {
            this.afterRead(file, detail, 'ad_image')
        },
        image_index_afterRead(file, detail) {
            this.afterRead(file, detail, 'index_image')
        },
        image_index_delete(file, detail) {
            console.log('image_index_delete:', file, detail)
            this.$API.shopEdit({index_image: ''}).then(res => {
                console.log(res)
            })
            return true;
        },
        onChangeSwitch() {
            this.$API.shopEdit({index_switch: this.index_switch ? 1 : 0}).then(res => {
                console.log(res)
            })
        },
        onChangeCarriage() {
            this.$API.shopEdit({carriage_status: this.carriage_status ? 1 : 0}).then(res => {
                console.log(res)
            })
        },
        getDistance() {
            let _this = this
            _this.$API.shopDistance().then(res => {
                _this.distance = [];
                res.data.distance.forEach(function (item) {
                    _this.distance.push(item)
                });
                _this.carriage_status = res.data.carriage_status === 1;
            })
        },
        onDistance(item, type) {
            if (type === 'add') {
                this.distance_data = {
                    id: 0
                };
            } else {
                this.distance_data = item;
            }
            this.distance_show = true
        },
        distance_del() {
            let _this = this
            Dialog.confirm({
                title: '删除运费规则',
                message: '确认要删除运费规则吗？',
            }).then(() => {
                _this.$API.shopDistanceDel({id: _this.distance_data.id}).then(res => {
                    _this.distance_show = false
                    _this.getDistance()
                    Notify({type: 'success', message: '删除成功'});
                })
            }).catch(() => {
            });
        },
        distance_confirm() {
            let _this = this
            if (this.distance_data.price < 0) {
                Notify('请输入运费价格');
                return false;
            }

            // 保存到数据库
            _this.$API.shopDistanceEdit(this.distance_data).then(res => {
                _this.distance_show = false
                _this.getDistance()
            })
        },
        afterRead(file, detail, item) {
            console.log(file, detail, item)
            file.status = 'uploading';
            file.message = '上传中...';

            let formData = new FormData();
            formData.append("file", file.file);

            this.$API.upload(formData).then(res => {
                file.status = 'done'
                console.log(res.data.url)
                this[item] = res.data.fullurl
                this.onImageConfirm(item, res.data.url)
                // this.row.item_image[item] = res.data.url
            }).catch(res => {
                file.status = 'failed'
                file.message = '上传失败'
                console.log(res)
            })
        },
        // 保存上传的图片
        onImageConfirm(item, url) {
            let data = {}
            data[item] = url
            this.$API.shopEdit(data).then(res => {
                console.log(res.data.url)
            }).catch(res => {
                console.log(res)
            })
        },
        onConfirm(value) {
            let that = this
            that.showPicker = false;
            that.value = value.text;
            // that.qrcodeUrl(value.keyId)

            that.$API.getQrcode({number: value.keyId}).then(res => {
                that.image = res.data
            });
        },
        onCConfirm(value, index) {
            let _this = this
            _this.tabB_category_name = value
            _this.tabB_category = _this.tab_C[index].id
            _this.tabBC_show = false
        },
        onCCancel() {
            this.tabBC_show = false
        },
        onConfirmini(value) {
            let that = this
            that.showPicker = false;
            that.value = value.text;
            // that.qrcodeUrl(value.keyId)

            that.$API.getMincode({number: value.keyId}).then(res => {
                that.image_mini = res.data
            });
        },
    },
}
</script>

<style scoped lang="less">

.ku-shop-index {
    padding-bottom: 120px;

    .ku-span-title {
        margin: 10px 0;
        position: relative;

        span {
            display: inline-block;
            width: 250px;
            background: #3cb371;
            padding: 10px 15px;
            font-size: 28px;
            color: #fff;
            border-radius: 10px;

            label {
                display: inline-block;
                float: left;
            }

            .van-icon {
                background: #D95E2D;
                border-radius: 50%;
                margin-left: 30px;
                margin-top: 3px;
                font-size: 32px;
                display: inline-block;
            }
        }

        .copy {
            position: absolute;
            width: 120px;
            border-radius: 5px;
            padding: 0;
            float: right;
            top: 15px;
            right: 10px;
            height: 40px;
            border: 0;
        }
        .copy-2 {
            background: #fff;
            border: 1px solid #999;
            width: 160px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .time-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
    }
    .morning-mode-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 4px 8px;
        padding: 10px 12px;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 14px rgba(39, 37, 31, 0.08);
        .morning-mode-title {
            font-size: 15px;
            font-weight: 800;
            color: #27251f;
        }
        .morning-mode-desc {
            font-size: 11px;
            color: #999;
            margin-top: 2px;
            line-height: 1.35;
        }
        .morning-btn {
            flex-shrink: 0;
            min-width: 108px;
            height: 32px;
            border-radius: 10px;
            background: #fff;
            border: 0;
            box-shadow: 0 4px 14px rgba(39, 37, 31, 0.08);
            color: #666;
            padding: 0 10px;
            font-size: 12px;
            font-weight: 800;
        }
        .morning-btn.text_kai {
            color: #fff;
            background: #3cb371;
            font-weight: 800;
        }
    }
    .grid-raise {
        .raise-empty { color: #c0392b; }
        .raise-off { color: #999; }
    }
    .morning_switch {
        display: none;
    }


    .grid {
        border-top: 1px solid #C8B7A3;
        border-bottom: 1px solid #C8B7A3;
        padding: 10px 0;

        .van-grid-item {
            font-size: 30px;
            line-height: 40px;
            overflow: hidden;

            /deep/ .van-grid-item__content {
                padding: 0;
            }

            span {
                &:nth-child(1) {
                    width: 64px;
                    height: 80px;
                    font-weight: bold;
                    overflow: hidden;
                }

                &:nth-child(2) {
                    width: 100%;
                    height: 40px;
                    overflow: hidden;
                }
            }
        }
    }

    .grid-raise {
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .van-grid-item {
            font-size: 24px;
            line-height: 40px;
            padding: 10px 0;

            /deep/ .van-grid-item__content {
                border: 1px solid #ddd;
                border-radius: 10px;
                padding: 0;
                background: none;
                margin: 0 8px;

                span {
                    width: 100%;
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &.action {
                        background: #006837;
                        color: white;
                    }
                    label {
                        margin-left: 25px;
                    }
                }
            }

        }

        .icon {
            width: 30px;
            height: 30px;
            padding: 2px 15px;
            font-size: 28px;
            font-weight: bold;
            border-radius: 10px;
            border: 1px solid #ddd;
        }
    }

    .ku-span {
        display: flex;

        .ku-span-title {
            display: inline-block;
            margin: 10px;
            width: 45%;
            text-align: center;
        }

        .span-1 {
            .van-field {
                border: 1px solid #999;
                width: 60%;
                height: 50px;
                padding: 0 20px;
                border-radius: 10px;
                display: flex;
                margin: 0 10px;
                justify-content: left;
                flex-direction: row;

                &:nth-child(1) {
                    margin-left: 10%;
                }
            }
        }

        .ku-tableware {
            width: 50%;
            display: inline-block;

            div {
                display: inline-block;
                height: 40px;
                line-height: 40px;
                font-size: 28px;
                font-weight: bold;
            }

            .van-field {
                width: 60px;
                border-radius: 5px;
                padding: 0;
                margin: 0 8px;
                border: 1px solid #999;
                overflow: visible;

                /deep/ .van-field__control {
                    text-align: center;
                    font-weight: normal;
                    font-size: 24px;
                    color: #D95E2D;
                }
            }
        }
    }

    .ku-span-password {
        display: flex;
        flex-direction: row;
        padding: 0 30px;

        .van-field {
            width: 100%;
            padding: 0 15px;
            height: 60px;
            line-height: 60px;
            border: 1px solid #999;
            margin: 0 10px;
            border-radius: 10px;
        }

        .van-button {
            width: 50%;
            height: 60px;
            line-height: 60px;
            padding: 0;
            border-radius: 10px;
        }
    }

    .pay_system {
        .van-button {
            border-radius: 10px;
            padding: 0 20px;
            height: 50px;
        }
    }

    .van-datetime-picker {
        position: fixed;
        bottom: 0;
        z-index: 2000;
        width: 100%;

        /deep/ .van-picker__columns {
            width: 280px;
            margin: 0 auto;
        }
    }
    .tabz_show{
        width: 90%;
        padding: 1rem 0;
        .tabz_discount{
            display: flex;
            .van-field{
                width: 50%;
                .van-field__label{
                    width: 20px;
                }
            }
        }
    }
    // 弹出层
    .tab_show {
        width: 80%;

        .title {
            height: 80px;
            line-height: 80px;
            font-size: 30px;
            padding-top: 15px;
        }

        .foot {
            .van-button {
                width: 50%;
                border: 0;
                padding: 0;

                &:nth-child(1) {
                    border-right: 2px solid #ebedf0;
                    color: #FF0000;
                }

                &:nth-child(2) {
                    color: #07c160;
                }
            }
        }
    }

    .popup-copy {
        background: #000;
        color: white;

        .van-radio-group {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;

            .van-radio {
                min-width: 400px;
                height: 60px;
                line-height: 60px;
                margin: 10px auto;
                padding: 5px 25px;
                border: 1px solid black;
                border-radius: 10px;
                text-align: center;
                display: block;
                font-size: 32px;

                /deep/ .van-radio__icon {
                    display: none;
                }

                /deep/ .van-radio__label {
                    color: white;
                }
            }

            .radio-active {
                border: 1px solid #9C4826;
            }
        }

        .foot {
            .van-button {
                background: #EA861E;
                margin: 20px;
                width: 180px;
                font-size: 30px;
                letter-spacing: 5px;

                &:nth-child(1) {
                    border: 0;
                    color: white;
                }
            }
        }
    }

    .ku-shop-qrcode {
        margin-top: 30px;

        .s1 {
            width: 85%;
            margin: 20px auto 50px auto;
            font: normal 28px/45px 'Microsoft YaHei', serif;
            padding: 30px 15px;
            color: black;
        }

        #qrcode {
            display: inline-block;
            background: url("../../../public/img/2.png") no-repeat;
            background-size: 100%;
            width: 600px;
            height: 360px;
            text-align: center;
            position: relative;

            /deep/ img {
                width: 260px;
                height: 260px;
                background-color: #fff; //设置白色背景色
                padding: 6px; // 利用padding的特性，挤出白边
                position: absolute;
                left: 165px;
                top: 15px;
            }
        }

        .s2 {
            margin-top: 30px;

            div {
                display: inline-block;
                vertical-align: top;
            }

            .van-field {
                width: 200px;
                height: 80px;
                line-height: 80px;
                font-size: 32px;
                font-weight: bold;
                padding: 0;
                text-align: center;
                border: 1px solid #000;
                border-radius: 10px;

                /deep/ .van-field__control {
                    text-align: center;
                }
            }

            .nowBtn {
                background: #E68925;
                color: #fff;
                font-size: 32px;
                width: 120px;
                height: 80px;
                line-height: 80px;
                padding: 0;
                margin-left: 30px;
                border-radius: 10px;
            }

            .van-image {
                width: 40px;
                margin: 3px 15px;
            }
        }

        .van-image {
            width: 50%;
            margin: 0 auto;
        }
    }
}
.Switch {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: bold;
}
</style>

<style lang="less">
/* unscoped: popup teleports to body */
.time-range-popup {
    .time-range-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 12px;
        border-bottom: 1px solid #ebedf0;
    }
    .tr-title {
        flex: 1;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #27251f;
    }
    .tr-btn {
        border: 0;
        background: transparent;
        font-size: 14px;
        padding: 6px 8px;
        min-width: 52px;
    }
    .tr-cancel { color: #969799; }
    .tr-ok { color: #07c160; font-weight: 700; }
    .time-range-cols {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding-bottom: 8px;
    }
    .time-range-col {
        flex: 1;
        min-width: 0;
        text-align: center;
        .van-datetime-picker,
        .van-picker {
            width: 100% !important;
            position: static !important;
        }
        .van-picker__columns {
            width: 100% !important;
            margin: 0 !important;
        }
    }
    .time-range-label {
        font-size: 14px;
        font-weight: 800;
        color: #3cb371;
        padding: 8px 0 0;
    }
}
</style>
